import { TinyMceService } from 'src/app/services/tinyMce.service';
import { ContentService } from 'src/app/services/content.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { TemplatesService } from 'src/app/services/templates.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-pages-make',
  templateUrl: './pages-make.page.html',
  styleUrls: ['./pages-make.page.scss'],
})
export class PagesMakePage implements OnInit {
  createPageForm: FormGroup;

  tinyMCEConfiguration;

  templateArray = [];

  pageArray = [];
  time;
  parent = 'none';

  constructor(
    private fb: FormBuilder,
    private contentService: ContentService,
    private tinyMCE: TinyMceService,
    private templateService: TemplatesService,
    private router: Router,
    public authService: AuthenticationService,
  ) {
    this.tinyMCEConfiguration = this.tinyMCE.tinyMCEConfiguration;
  }

  ngOnInit() {
    this.authService.login();
    this.time = Math.floor(Date.now()/1000);
    this.createPageForm = this.fb.group({
      title: [''],
      homepage: ['false'],
      template: ['main'],
      forwardTick: ['false'],
      forward: [''],
      body: [''],
      parent: ['_top'],
      url: [''],
      published: ['1'],
      timestamp: [''],
      metaTitle: [''],
      metaDescription: [''],
      order: [''],
      slug: [''],
    });
    this.onListTemplates();
    this.onListPages();
  }

  ionViewWillEnter() {
    if (this.authService.isLoggedIn === false) {
      this.router.navigateByUrl('/admin/login');
    }
  }

  formSubmit() {
    if (!this.createPageForm.valid) {
      console.log('not valid');
      return false;
    } else {
      this.contentService
        .createPage(this.createPageForm.value)
        .then((res) => {
          console.log(res);
          this.createPageForm.reset();

          this.router.navigateByUrl('/admin/pages');
        })
        .catch((error) => console.log(error));
    }
  }

  onListTemplates() {
    const list = this.templateService.loadLiveList();
    list.valueChanges({idField: 'id'}).subscribe((ss) => {
      this.templateArray = ss;
      // console.log(this.pageArray);
    });
  }

  public onKeyUp(event: any) {
    const newValue = event.target.value;
    const regExp = new RegExp('^[a-z0-9?-]+$');
    if (! regExp.test(newValue)) {
      event.target.value = newValue.slice(0, -1);
    }
  }

  onListPages() {
    const list = this.contentService.loadLiveList();
    list.valueChanges({idField: 'id'}).subscribe((ss) => {
      this.pageArray = ss;
      // console.log(this.pageArray);
    });
  }

}
